 

import {Action, action, Thunk, thunk} from 'easy-peasy';

export interface FilterSidebarOpenModel {
    filterSidebarOpen: boolean;
    filterSidebarWasOpen: boolean;
    setFilterSidebarOpen: Action<FilterSidebarOpenModel, boolean>;
    setFilterSidebarWasOpen: Action<FilterSidebarOpenModel, boolean>;
    setFilterSidebarOpenWithMemory: Thunk<FilterSidebarOpenModel, boolean>;
}

export default <FilterSidebarOpenModel>{
    filterSidebarOpen: false,
    // For cases when we want to remember if it was opened previously when it was automatically shown
    filterSidebarWasOpen: false,
    setFilterSidebarOpen: action((state, open) => {
        state.filterSidebarOpen = open;
        if (!open) {
            state.filterSidebarWasOpen = false;
        }
    }),
    setFilterSidebarWasOpen: action((state, wasOpen) => {
        state.filterSidebarWasOpen = wasOpen;
    }),
    setFilterSidebarOpenWithMemory: thunk((actions, open, {getState}) => {
        if (open) {
            actions.setFilterSidebarWasOpen(getState().filterSidebarOpen);
            actions.setFilterSidebarOpen(true);
        } else {
            actions.setFilterSidebarOpen(getState().filterSidebarWasOpen);
            actions.setFilterSidebarWasOpen(false);
        }
    }),
};
